import { BASE_FTM_SCAN_URL } from 'config'

export const getFtmScanAddressUrl = (address: string) => {
  return `${BASE_FTM_SCAN_URL}/address/${address}`
}

export const getFtmScanTransactionUrl = (transactionHash: string) => {
  return `${BASE_FTM_SCAN_URL}/tx/${transactionHash}`
}

export const getFtmScanBlockNumberUrl = (block: string | number) => {
  return `${BASE_FTM_SCAN_URL}/block/${block}`
}

export const getFtmScanBlockCountdownUrl = (block: string | number) => {
  return `${BASE_FTM_SCAN_URL}/block/countdown/${block}`
}
